// cookie-consent.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private cookieConsentKey = 'cookieConsent';

  hasConsented(): boolean {
    return localStorage.getItem(this.cookieConsentKey) === 'true';
  }

  setConsent(consent: boolean) {
    localStorage.setItem(this.cookieConsentKey, consent ? 'true' : 'false');
  }
}
